import { render, staticRenderFns } from "./ChecklistSteps.vue?vue&type=template&id=3618bf68&scoped=true&"
import script from "./ChecklistSteps.vue?vue&type=script&lang=js&"
export * from "./ChecklistSteps.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistSteps.vue?vue&type=style&index=0&id=3618bf68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3618bf68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3618bf68')) {
      api.createRecord('3618bf68', component.options)
    } else {
      api.reload('3618bf68', component.options)
    }
    module.hot.accept("./ChecklistSteps.vue?vue&type=template&id=3618bf68&scoped=true&", function () {
      api.rerender('3618bf68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/customers/checklist/ChecklistSteps.vue"
export default component.exports